import React from 'react';
import styled from 'styled-components';

import type {
  IResourceAnnouncementItem,
  IResourceDatabaseView,
  IResourceDocumentItem,
  IResourceItemType,
  IResourceLinkItem,
} from '@/api/types';

import { isOfType } from '@/helpers';
import { ResourceAnnouncement, ResourceDatabaseView, ResourceDocument, ResourceLink } from '@/assets/icons';

interface IProps {
  data: IResourceItemType | IResourceDatabaseView;
}

const ResourcesIcon = ({ data }: IProps): React.ReactElement => {
  if (isOfType<IResourceAnnouncementItem>(data, 'announcementId')) {
    return <ResourceIcon src={ResourceAnnouncement} />;
  }

  if (isOfType<IResourceDocumentItem>(data, 'documentId')) {
    return <ResourceIcon src={ResourceDocument} />;
  }

  if (isOfType<IResourceLinkItem>(data, 'linkId')) {
    return <ResourceIcon src={ResourceLink} />;
  }

  if (isOfType<IResourceDatabaseView>(data, 'rtxDatabase_Id')) {
    return <ResourceIcon src={ResourceDatabaseView} />;
  }

  return <></>;
};

export { ResourcesIcon };

const ResourceIcon = styled.img`
  width: 100%;
  max-height: 16px;
`;
